// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3yH9D","col":"styles_col__9awue"};